import { apiSlice } from "../api/apiSlice";

export const propertyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserProperties: builder.query({
      query: (params) => {
        if (typeof params === "string")
          return `/property/user/?userid=${params}`;
        const queryParams = new URLSearchParams();
        if (params?.userid) queryParams.append("userid", params.userid);
        if (params?.companyid)
          queryParams.append("companyid", params.companyid);
        return `/property/user/?${queryParams.toString()}`;
      },
      providesTags: ["UserProperties"],
    }),
    createProperty: builder.mutation({
      query: (data) => ({
        url: "/property/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UserProperties"],
    }),
    getPropertyById: builder.query({
      query: (id) => `/property/id/?id=${id}`,
      providesTags: (result, error, id) => [{ type: "Property", id }],
    }),
    deleteProperty: builder.mutation({
      query: (id) => ({
        url: `/property/?id=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["UserProperties", "Property"],
    }),
    getFilteredProperties: builder.query({
      query: (queryString) => `/property/filter/?${queryString}`,
    }),
    getPropertiesByCompanyId: builder.query({
      query: (companyid) => `/property/company/?companyid=${companyid}`,
      providesTags: (result, error, companyid) => [{ type: 'UserProperties', id: companyid }],
    }),
  }),
});

export const {
  useGetUserPropertiesQuery,
  useLazyGetUserPropertiesQuery,
  useCreatePropertyMutation,
  useGetPropertyByIdQuery,
  useDeletePropertyMutation,
  useLazyGetFilteredPropertiesQuery,
  useGetPropertiesByCompanyIdQuery,
} = propertyApiSlice;
